import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { api, RequestStatus } from "@/logic/api";
import { Fragment, useContext, useEffect } from "react";
import { SessionContext } from "@/utility/useSession";
import { UATEnvironmentSection } from "./UATEnvironmentSection";
import { ProgressView } from "@/components/notifications/progress/ProgressView";

export const TasksSection = () => {
  const { t } = useTranslation();
  const session = useContext(SessionContext);
  const listDefinitions = api.hooks.task.listDefinitions();

  useEffect(() => {
    listDefinitions.send(session.current.context, { paging: { limit: 100 } });
  }, []);

  return (
    <ProgressView status={listDefinitions.status}>
      {listDefinitions.data?.map((definition) => (
        <Fragment key={definition.uuid}>
          {(definition.taskType === "copyTenantData") && (
            <UATEnvironmentSection
              definition={definition}
              key={definition.uuid}
            />
          )}
        </Fragment>
      ))}
      {listDefinitions.status === RequestStatus.loaded &&
        listDefinitions.data?.length === 0 && (
          <Box sx={{ textAlign: 'center', py: 3, color: 'text.secondary' }}>
            {t("settings.noTasksFound")}
          </Box>
        )}
    </ProgressView>
  );
};
